<template>
  <div class="goodsManageSet">
    <div class="banner">
      <img src="../../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon">
        <i class="iconfont icon-shangpinsku"></i>
      </div>
      <div class="breadcrumb_item">SKU管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">商品配件</div>
    </div>
    <div class="tit">商品配件</div>

    <div class="input_box search">
      <span class="search_icon" @click="handleSearch"></span>
      <van-field
        v-model="params.keyword"
        ref="input"
        placeholder="输入属性标签关键字查找"
        @focus="handleFocus"
        @blur="handleBlur"
      />
    </div>

    <div class="main_content">
      <div class="data_list" v-if="dataList.length > 0">
        <div
          class="item_card"
          v-for="item in dataList"
          :key="item.id"
          @click="handleEdit(item.id)"
        >
          <!-- <div class="img_box" >
            <van-image width="100%" height="100%" :src="item.pic"> </van-image>
          </div> -->
          <div class="text">
            <p>
              配件商品SKU：<span>{{ item.cmsku }}</span>
            </p>
            <p>
              配件商品名称：<span>{{ item.cmname }}</span>
            </p>
            <p>
              每件配套数量：<span>{{ item.num }}</span>
            </p>

            <p>
              是否增加价格：<span>{{
                item.isaddprice == 0 ? "否" : "是"
              }}</span>
            </p>
            <p>
              价格：<span>{{ item.price }}</span>
            </p>
            <p>
              配件所属商品ID：<span>{{ item.cmid }}</span>
            </p>

            <p>
              所属企业名称：<span>{{ item.qyname ? item.qyname : "" }}</span>
            </p>
            <p>
              添加日期：<span>{{ item.addtime | formatDate }}</span>
            </p>
          </div>
          <div class="editBtn" @click="handleEdit(item.id)">编辑配件→</div>
        </div>
      </div>

      <van-empty description="暂无数据" v-else />
    </div>

    <!-- <div class="return-fixd flex-rowc" v-if="isShowTabbar">
      <div class="primary-button" @click="handleAdd">+新增属性标签</div>
      <div class="default-button" @click="handleReturn">返回</div>
    </div> -->
    <div class="fixd_button_btm flex-rowl" v-if="isShowTabbar">
      <!-- <div class="return-fixd"> -->
      <div class="item return" @click="handleReturn">返回</div>
      <div class="item" @click="handleAdd">新增商品配件</div>
    </div>
  </div>
</template>

<script>
import {encryptstringview} from '../../../api/api'
import { getShopAttachmentList } from "../../../api/shop";
import { mapState } from "vuex";
export default {
  name: "cShopAttachment",
  data() {
    return {
      isShowTabbar: true,
      searchTxt: "",

      parantId: "",

      params: {
        pageindex: 1,
        pagesize: 20,
        keyword: "",
        cmid: "",
      },
      loading: false, // 是否正在加载中
      listTotal: 0,
      dataList: [],
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  mounted() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }

    window.addEventListener("scroll", this.handleSrcoll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleSrcoll);
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.params.cmid = id;
        this.getShopAttachmentList();
      } else {
        this.$router.back();
      }
    },

    getShopAttachmentList() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      this.loading = true;
      getShopAttachmentList(this.params).then((res) => {
        this.dataList = [...this.dataList, ...res.list];
        this.listTotal = res.total;
        this.loading = false;
        Toast.clear();
      });
    },
    // 滚动事件
    handleSrcoll() {
      const windowHeight = window.innerHeight; // 窗口可见高度
      const documentHeight = document.documentElement.scrollHeight; // 文档高度
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop; // 滚动条距离顶部的距离

      if (
        scrollTop + windowHeight >= documentHeight &&
        !this.loading &&
        this.dataList.length < this.listTotal
      ) {
        this.params.pageindex += 1;
        this.getShopAttachmentList();
      }
    },

    handleSearch() {
      this.params.pageindex = 1;
      this.dataList = [];
      this.getShopAttachmentList();
    },

    handleReturn() {
      history.back();
    },

    handleEdit(id) {
      let { cmId, cmSku } = this.$route.params;
      this.$router.push({
        path: "/commondityIndex/cManageEdit/cShopAttachmentSet",
        query: { id, cmId, cmSku },
      });
    },
    handleAdd() {
      let { cmId, cmSku } = this.$route.params;
      this.$router.push({
        path: "/commondityIndex/cManageEdit/cShopAttachmentSet",
        query: { cmId, cmSku },
      });
    },

    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 60px;
  }
  .tit {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 50px;
  }
  .input_box {
    &.search {
      margin-bottom: 30px;
    }
  }
  .main_content {
    .item_card {
      border: 2px solid #dedede;
      border-radius: 30px;
      width: 650px;
      padding: 45px 37px 85px;
      box-sizing: border-box;
      margin: auto;
      position: relative;
      margin-bottom: 60px;
      .img_box {
        width: 250px;
        height: 250px;
        margin: auto;
        background: #e8e8e8;
        margin-bottom: 45px;
      }
      p {
        font-size: 22px;
        color: #404d6c;
        text-align: left;
        line-height: 45px;
      }
      .editBtn {
        position: absolute;
        width: 200px;
        height: 50px;
        line-height: 50px;
        background: #6e5c86;
        border-radius: 25px;
        font-size: 20px;
        color: #fff;
        right: 20px;
        bottom: 20px;
        text-align: center;
      }
    }
  }
}
</style>